// utils/imagePreloader.js
export const preloadImages = (imageUrls, onProgress) => {
  return new Promise((resolve, reject) => {
    const totalImages = imageUrls.length;
    let loadedImages = 0;
    const loadedImageElements = {};

    if (totalImages === 0) {
      onProgress?.(100);
      resolve({});
      return;
    }

    imageUrls.forEach((url, index) => {
      const img = new Image();
      
      img.onload = () => {
        loadedImages++;
        loadedImageElements[index] = img;
        const progress = (loadedImages / totalImages) * 100;
        onProgress?.(progress);
        
        if (loadedImages === totalImages) {
          resolve(loadedImageElements);
        }
      };

      img.onerror = (error) => {
        console.warn(`Failed to load image: ${url}`, error);
        loadedImages++;
        const progress = (loadedImages / totalImages) * 100;
        onProgress?.(progress);
        
        if (loadedImages === totalImages) {
          resolve(loadedImageElements);
        }
      };

      img.src = url;
    });
  });
};